import { PageViewEventLogger } from '@repo/tracking-service';
import Head from 'next/head';
import { useEffect } from 'react';

import { StaticImageSection } from '@/components/event/Sections';
import { LandingCtaButton } from '@/components/landing/LandingCtaButton';
import RefundFAQ from '@/components/landing/RefundFAQ';
import HomeLayout from '@/components/layout/HomeLayout';

const CapitalGainLanding = () => {
  useEffect(() => {
    sessionStorage.setItem('isPersonalTritx', 'true');
  }, []);

  return (
    <>
      <HomeLayout>
        <StaticImageSection
          sectionId={'01'}
          imagePath={'/refund/images/home/landing/img_landing_capital-gain_01.png'}
          className={'bg-[linear-gradient(180deg,#fff_30%,var(--blue-100,#E9F3FF)_65%,var(--yellow-200,#FFF4BF)_100%)] [&_img]:max-w-[700px] [&_img]:mx-auto'}
        />
        <StaticImageSection
          sectionId={'02'}
          imagePath={'/refund/images/home/landing/img_landing_capital-gain_02.png'}
          className={'bg-neutral-background-main [&_img]:max-w-[700px] [&_img]:mx-auto'}
        />
        <StaticImageSection
          sectionId={'03'}
          imagePath={'/refund/images/home/landing/img_landing_capital-gain_03.png'}
          className={'bg-[linear-gradient(180deg,#E9F3FF_0%,#FFF_100%)] [&_img]:max-w-[700px] [&_img]:mx-auto'}
        />
        <StaticImageSection
          sectionId={'04'}
          imagePath={'/refund/images/home/landing/img_landing_capital-gain_04.png'}
          className={'[&_img]:max-w-[700px] [&_img]:mx-auto'}
        />
        <StaticImageSection
          sectionId={'05'}
          imagePath={'/refund/images/home/landing/img_landing_capital-gain_05.png'}
          className={'bg-neutral-background-inverse-main [&_img]:max-w-[700px] [&_img]:mx-auto'}
        />
        <RefundFAQ sectionId={'06'} maxWidth={'700'} />
      </HomeLayout>
      <LandingCtaButton />
      <PageViewEventLogger pageName={'landing_capital-gain'} eventOption={{ isUseAirbridge: true, isUseGoogleAnalytics: true }} />
    </>
  );
};

export default CapitalGainLanding;

CapitalGainLanding.getLayout = (page: React.ReactElement) => {
  return (
    <>
      <Head>
        <title>양도소득세 환급금 무료 진단 | 비즈넵 환급</title>
      </Head>
      {page}
    </>
  );
};
